import React from "react";
import {
  ArcDroneMarker,
  ArcPolyline,
} from "@src/core/controllers";
import { arcHistoryOrderPath } from "@src/core/extensions";
import { OrderMissionEntity } from "@src/features/order/entities";
import { Marker } from "@react-google-maps/api";
import destionation from '@src/assets/destination.svg';

interface ErrorMapProps {
  order: OrderMissionEntity;
}

const ErrorMap: React.FC<ErrorMapProps> = (props) => {
  const { order } = props;

  if (!order) return null;

  return (
    <React.Fragment>
      <ArcPolyline.default path={arcHistoryOrderPath(order)} />

      {(order as any).deliveryLocation && (
        <Marker 
          draggable={false}
          position={{ lat: Number((order as any).deliveryLocation.latitude), lng: Number((order as any).deliveryLocation.longitude) }} 
          icon={{ 
            url: destionation,  
            scaledSize: new window.google.maps.Size(100, 50),
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(17, 44),  
          }} />
      )}

      {(order as any).drone &&
        (order as any).drone.latitude &&
        (order as any).drone.longitude && (
        <ArcDroneMarker.error
          position={{
            lat: Number((order as any).drone.latitude),
            lng: Number((order as any).drone.longitude),
          }}
        />
      )}
    </React.Fragment>
  );
};

export default ErrorMap;
